import { getStatusForId as getStatus } from '@ms/yammer-data-support';

import type { Group, GroupCoverImage, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';
import type { FindById, FindByIdThrows } from '../findById';

/**
 * @deprecated PERFORMANCE This returns an entity object and will force re-renders whenever an API call etc. updates the entity.
 * This should be replaced with a `getGroupCoverImageField` selector.
 */
export const findById: FindById<'groupCoverImages'> = createFindById('groupCoverImages');
/**
 * @deprecated PERFORMANCE This returns an entity object and will force re-renders whenever an API call etc. updates the entity.
 * This should be replaced with a `getGroupCoverImageFieldThrows` selector.
 */
export const findByIdThrows: FindByIdThrows<'groupCoverImages'> = createFindByIdThrows('groupCoverImages');

type IsFulfilled = (state: YammerState, groupId: Group['id']) => boolean;
export const isFulfilled: IsFulfilled = (state, groupId) => getStatus(state.groupCoverImages, groupId) === 'fulfilled';

type GetFulfilledCoverImages = (state: YammerState) => Record<string, GroupCoverImage>;
/**
 * @deprecated PERFORMANCE This returns the entire object of fulfilled entity objects, which is a new object reference whenever
 * ANY entity in this reducer gets updated and forces unnecessary re-renders. Consumers should use more granular selectors.
 */
export const getFulfilledCoverImages: GetFulfilledCoverImages = (state) => state.groupCoverImages.fulfilled.byId;
